import { render, staticRenderFns } from "./unsaved-banner.vue?vue&type=template&id=c56b9e0c&scoped=true"
import script from "./unsaved-banner.vue?vue&type=script&lang=js"
export * from "./unsaved-banner.vue?vue&type=script&lang=js"
import style0 from "./unsaved-banner.vue?vue&type=style&index=0&id=c56b9e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56b9e0c",
  null
  
)

export default component.exports